var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9398 19.5466C10.4398 19.5466 8.22982 18.2666 6.93982 16.3466C6.96982 14.3466 10.9398 13.2466 12.9398 13.2466C14.9398 13.2466 18.9098 14.3466 18.9398 16.3466C18.2787 17.331 17.3857 18.1377 16.3394 18.6957C15.2931 19.2538 14.1256 19.5459 12.9398 19.5466ZM12.9398 5.34656C13.7355 5.34656 14.4985 5.66263 15.0611 6.22524C15.6237 6.78785 15.9398 7.55091 15.9398 8.34656C15.9398 9.14221 15.6237 9.90527 15.0611 10.4679C14.4985 11.0305 13.7355 11.3466 12.9398 11.3466C12.1442 11.3466 11.3811 11.0305 10.8185 10.4679C10.2559 9.90527 9.93982 9.14221 9.93982 8.34656C9.93982 7.55091 10.2559 6.78785 10.8185 6.22524C11.3811 5.66263 12.1442 5.34656 12.9398 5.34656ZM12.9398 2.34656C11.6266 2.34656 10.3262 2.60522 9.11298 3.10777C7.89973 3.61031 6.79734 4.34691 5.86875 5.27549C3.99339 7.15086 2.93982 9.6944 2.93982 12.3466C2.93982 14.9987 3.99339 17.5423 5.86875 19.4176C6.79734 20.3462 7.89973 21.0828 9.11298 21.5854C10.3262 22.0879 11.6266 22.3466 12.9398 22.3466C15.592 22.3466 18.1355 21.293 20.0109 19.4176C21.8862 17.5423 22.9398 14.9987 22.9398 12.3466C22.9398 6.81656 18.4398 2.34656 12.9398 2.34656Z",
    fill: "#586474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.e65a88468a335f2e6314502adbb549fc.svg";
export { ForwardRef as ReactComponent };